// Mock data for G&B Wood website

export const companyInfo = {
  name: "G&B Wood",
  tagline: "Specialisti nella posa parquet e lavori in legno su misura",
  subtitle: "Precisione artigianale, materiali di qualità e risultati garantiti.",
  phone: "+39 349 611 3675",
  email: "preventivi@gbwood.it",
  whatsapp: "393496113675",
  address: "Via Tagliata, 9, 91022 Castelvetrano (TP)",
  hours: "Lun-Ven: 8:00-18:00 | Sab: 9:00-13:00",
  area: "Provincia di Trapani"
};

export const images = {
  hero: "https://images.unsplash.com/photo-1560185008-b033106af5c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxoYXJkd29vZCUyMGZsb29yaW5nfGVufDB8fHx8MTc2NDU4MzA3Nnww&ixlib=rb-4.1.0&q=85",
  parquetStack: "https://images.unsplash.com/photo-1693722232517-9c19a620258c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwYXJxdWV0JTIwZmxvb3Jpbmd8ZW58MHx8fHwxNzY0NTgzMDYwfDA&ixlib=rb-4.1.0&q=85",
  woodSamples: "https://images.unsplash.com/photo-1693722232879-7fd691f7ab01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxwYXJxdWV0JTIwZmxvb3Jpbmd8ZW58MHx8fHwxNzY0NTgzMDYwfDA&ixlib=rb-4.1.0&q=85",
  parquetPieces: "https://images.unsplash.com/photo-1693722232788-2a03684b5e60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxwYXJxdWV0JTIwZmxvb3Jpbmd8ZW58MHx8fHwxNzY0NTgzMDYwfDA&ixlib=rb-4.1.0&q=85",
  modernStudy: "https://images.unsplash.com/photo-1673401188197-f88402d0b029?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHx3b29kZW4lMjBmbG9vciUyMGludGVyaW9yfGVufDB8fHx8MTc2NDU4MzA2NXww&ixlib=rb-4.1.0&q=85",
  bedroom: "https://images.pexels.com/photos/34983171/pexels-photo-34983171.jpeg",
  elegantInterior: "https://images.pexels.com/photos/3932930/pexels-photo-3932930.jpeg",
  craftsman1: "https://images.unsplash.com/photo-1721508490122-445daade2d39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHx3b29kJTIwY3JhZnRzbWFufGVufDB8fHx8MTc2NDU4MzA3MHww&ixlib=rb-4.1.0&q=85",
  craftsman2: "https://images.unsplash.com/photo-1721508490084-1b1de5b230d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHx3b29kJTIwY3JhZnRzbWFufGVufDB8fHx8MTc2NDU4MzA3MHww&ixlib=rb-4.1.0&q=85",
  craftsman3: "https://images.unsplash.com/photo-1660796334938-cf0b03be7e6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHx3b29kJTIwY3JhZnRzbWFufGVufDB8fHx8MTc2NDU4MzA3MHww&ixlib=rb-4.1.0&q=85",
  minimalist: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxoYXJkd29vZCUyMGZsb29yaW5nfGVufDB8fHx8MTc2NDU4MzA3Nnww&ixlib=rb-4.1.0&q=85",
  artistic: "https://images.unsplash.com/photo-1684358868651-cfb51fa88032?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxoYXJkd29vZCUyMGZsb29yaW5nfGVufDB8fHx8MTc2NDU4MzA3Nnww&ixlib=rb-4.1.0&q=85"
};

export const services = [
  {
    id: "posa-parquet",
    title: "Posa Parquet",
    shortDesc: "Installazione professionale di pavimenti in legno con tecniche tradizionali e moderne.",
    fullDesc: "La posa del parquet è un'arte che richiede precisione e competenza. Offriamo posa flottante, incollata e chiodata, garantendo risultati impeccabili per ogni tipo di ambiente. Utilizziamo solo materiali certificati e tecniche all'avanguardia.",
    benefits: ["Posa flottante, incollata o chiodata", "Materiali certificati FSC", "Garanzia 10 anni sulla posa", "Sopralluogo gratuito"],
    image: "https://images.unsplash.com/photo-1560185008-b033106af5c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxoYXJkd29vZCUyMGZsb29yaW5nfGVufDB8fHx8MTc2NDU4MzA3Nnww&ixlib=rb-4.1.0&q=85",
    icon: "Layers"
  },
  {
    id: "levigatura",
    title: "Levigatura e Lucidatura",
    shortDesc: "Rinnova il tuo parquet con la levigatura professionale e la lucidatura a specchio.",
    fullDesc: "Con la levigatura rimuoviamo graffi, macchie e segni del tempo dal tuo parquet, riportandolo al suo splendore originale. La successiva lucidatura protegge il legno e ne esalta la bellezza naturale.",
    benefits: ["Rimozione graffi e macchie", "Lucidatura a specchio", "Trattamento protettivo incluso", "Risultato garantito"],
    image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxoYXJkd29vZCUyMGZsb29yaW5nfGVufDB8fHx8MTc2NDU4MzA3Nnww&ixlib=rb-4.1.0&q=85",
    icon: "Sparkles"
  },
  {
    id: "riparazione",
    title: "Riparazione Parquet",
    shortDesc: "Interventi di riparazione mirati per danni localizzati al tuo pavimento in legno.",
    fullDesc: "Non sempre è necessario sostituire l'intero pavimento. I nostri tecnici intervengono con precisione chirurgica per riparare doghe danneggiate, eliminare cigolii e risolvere problemi di sollevamento.",
    benefits: ["Sostituzione doghe singole", "Eliminazione cigolii", "Riparazione sollevamenti", "Intervento rapido"],
    image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&auto=format&fit=crop&q=80",
    icon: "Wrench"
  },
  {
    id: "battiscopa",
    title: "Installazione Battiscopa",
    shortDesc: "Finitura perfetta con battiscopa in legno coordinati al tuo pavimento.",
    fullDesc: "Il battiscopa è il dettaglio che completa l'opera. Installiamo battiscopa in legno massello o MDF, coordinati al tuo parquet, con tagli a 45° perfetti e fissaggio invisibile.",
    benefits: ["Legno massello o MDF", "Tagli a 45° precisi", "Fissaggio invisibile", "Ampia scelta essenze"],
    image: "https://images.unsplash.com/photo-1693722232879-7fd691f7ab01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxwYXJxdWV0JTIwZmxvb3Jpbmd8ZW58MHx8fHwxNzY0NTgzMDYwfDA&ixlib=rb-4.1.0&q=85",
    icon: "Ruler"
  },
  {
    id: "porte-interne",
    title: "Installazione Porte Interne",
    shortDesc: "Montaggio professionale di porte interne in legno per la tua casa.",
    fullDesc: "Installiamo porte interne di ogni tipologia: battenti, scorrevoli, a libro. Garantiamo allineamento perfetto, funzionamento silenzioso e finiture impeccabili.",
    benefits: ["Porte battenti e scorrevoli", "Allineamento perfetto", "Maniglieria inclusa", "Finiture personalizzate"],
    image: "https://customer-assets.emergentagent.com/job_befa5430-9766-4d98-9662-0c4c6d191c67/artifacts/e8mls79s_Gemini_Generated_Image_rwnoderwnoderwno%20%281%29.png",
    icon: "DoorOpen"
  },
  {
    id: "montaggio-mobili",
    title: "Montaggio Mobili",
    shortDesc: "Assemblaggio e montaggio professionale di mobili in legno.",
    fullDesc: "Dalla cucina all'armadio, dal mobile TV alla libreria: montiamo mobili di ogni tipo con precisione e cura del dettaglio. Servizio disponibile anche per mobili già acquistati.",
    benefits: ["Montaggio cucine complete", "Armadi e cabine armadio", "Mobili IKEA e altri brand", "Smaltimento imballi"],
    image: "https://customer-assets.emergentagent.com/job_befa5430-9766-4d98-9662-0c4c6d191c67/artifacts/7q7b6130_Gemini_Generated_Image_fmz8upfmz8upfmz8%20%281%29.png",
    icon: "Sofa"
  },
  {
    id: "trattamenti",
    title: "Trattamenti Protettivi",
    shortDesc: "Protezione del legno con oli, cere e vernici di alta qualità.",
    fullDesc: "Prolunghiamo la vita del tuo parquet con trattamenti protettivi specifici: olio naturale, cera d'api, vernici all'acqua. Ogni trattamento è scelto in base al tipo di legno e all'uso dell'ambiente.",
    benefits: ["Oli naturali", "Cere d'api", "Vernici all'acqua", "Protezione UV"],
    image: "https://customer-assets.emergentagent.com/job_befa5430-9766-4d98-9662-0c4c6d191c67/artifacts/z3gleucv_Gemini_Generated_Image_f62xzef62xzef62x%20%281%29.png",
    icon: "Shield"
  },
  {
    id: "laminati",
    title: "Posa Laminati",
    shortDesc: "Alternativa economica al parquet con estetica e resistenza eccellenti.",
    fullDesc: "Il laminato è la soluzione ideale per chi cerca l'estetica del legno con un budget contenuto. Offriamo posa professionale di laminati di alta qualità, resistenti all'usura e facili da mantenere.",
    benefits: ["Ottimo rapporto qualità/prezzo", "Alta resistenza all'usura", "Facile manutenzione", "Ampia scelta decori"],
    image: "https://images.unsplash.com/photo-1693722232517-9c19a620258c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwYXJxdWV0JTIwZmxvb3Jpbmd8ZW58MHx8fHwxNzY0NTgzMDYwfDA&ixlib=rb-4.1.0&q=85",
    icon: "Grid3X3"
  }
];

export const whyChooseUs = [
  {
    title: "Esperienza Trentennale",
    description: "Oltre 30 anni di esperienza nel settore della posa parquet e lavorazioni in legno.",
    icon: "Award"
  },
  {
    title: "Materiali Certificati",
    description: "Utilizziamo solo legni certificati FSC e prodotti ecologici per la salute della tua casa.",
    icon: "BadgeCheck"
  },
  {
    title: "Garanzia Decennale",
    description: "Tutti i nostri lavori sono coperti da garanzia fino a 10 anni sulla posa.",
    icon: "ShieldCheck"
  },
  {
    title: "Preventivi Gratuiti",
    description: "Sopralluogo e preventivo dettagliato gratuiti, senza impegno.",
    icon: "FileText"
  },
  {
    title: "Puntualità Garantita",
    description: "Rispettiamo sempre i tempi concordati. Il tuo tempo è prezioso.",
    icon: "Clock"
  },
  {
    title: "Assistenza Post-Vendita",
    description: "Non ti lasciamo solo dopo il lavoro. Siamo sempre disponibili per consulenza e manutenzione.",
    icon: "Headphones"
  }
];

export const testimonials = [
  {
    name: "Marco Ferrara",
    location: "Castelvetrano",
    text: "Professionalità impeccabile. Hanno posato il parquet in rovere in tutta la casa e il risultato è stupendo. Consigliatissimi!",
    rating: 5,
    service: "Posa Parquet"
  },
  {
    name: "Laura Ferrante",
    location: "Marsala",
    text: "Il mio vecchio parquet sembrava da buttare, invece con la levigatura l'hanno riportato a nuova vita. Lavoro eccezionale!",
    rating: 5,
    service: "Levigatura"
  },
  {
    name: "Giovanni Catania",
    location: "Mazara del Vallo",
    text: "Puntuali, precisi e puliti. Hanno montato tutte le porte interne in una giornata. Ottimo rapporto qualità/prezzo.",
    rating: 5,
    service: "Porte Interne"
  },
  {
    name: "Alessia Ferraro",
    location: "Trapani",
    text: "Cercavo qualcuno per riparare alcune doghe danneggiate. Intervento rapido e risultato invisibile. Grazie!",
    rating: 5,
    service: "Riparazione"
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "Villa Moderna Castelvetrano",
    description: "Posa parquet rovere naturale 180mq con disegno a spina di pesce ungherese.",
    category: "Posa Parquet",
    image: "https://customer-assets.emergentagent.com/job_befa5430-9766-4d98-9662-0c4c6d191c67/artifacts/3rh33gfe_Gemini_Generated_Image_lxehkglxehkglxeh%20%281%29.png"
  },
  {
    id: 2,
    title: "Appartamento Centro Marsala",
    description: "Levigatura e lucidatura parquet antico con recupero delle venature originali.",
    category: "Levigatura",
    image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxoYXJkd29vZCUyMGZsb29yaW5nfGVufDB8fHx8MTc2NDU4MzA3Nnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Loft Mazara del Vallo",
    description: "Posa laminato effetto legno invecchiato per ambiente industrial chic.",
    category: "Laminati",
    image: "https://customer-assets.emergentagent.com/job_befa5430-9766-4d98-9662-0c4c6d191c67/artifacts/itkq58ks_Gemini_Generated_Image_49lf5y49lf5y49lf%20%281%29.png"
  },
  {
    id: 4,
    title: "Attico Vista Mare Trapani",
    description: "Posa parquet teak con trattamento protettivo per terrazzo coperto.",
    category: "Posa Parquet",
    image: "https://customer-assets.emergentagent.com/job_befa5430-9766-4d98-9662-0c4c6d191c67/artifacts/bpo1m3sl_Gemini_Generated_Image_m6xpm6xpm6xpm6xp%20%281%29.png"
  },
  {
    id: 5,
    title: "Ufficio Direzionale Alcamo",
    description: "Installazione completa porte interne in noce canaletto per ambiente executive.",
    category: "Porte Interne",
    image: "https://customer-assets.emergentagent.com/job_befa5430-9766-4d98-9662-0c4c6d191c67/artifacts/tc96c7pz_Gemini_Generated_Image_8tcxbk8tcxbk8tcx%20%281%29.png"
  },
  {
    id: 6,
    title: "Baglio Ristrutturato Salemi",
    description: "Recupero e trattamento parquet originale anni '50 con olio naturale.",
    category: "Trattamenti",
    image: "https://customer-assets.emergentagent.com/job_parquet-expert-1/artifacts/ik26tq9d_Gemini_Generated_Image_bilhmrbilhmrbilh%20%281%29.png"
  }
];

export const aboutContent = {
  title: "La Nostra Storia",
  subtitle: "Passione per il legno dal 1990",
  story: "G&B Wood nasce dalla passione e dall'esperienza di Carmine Avilio, artigiano specializzato nella posa parquet e nella lavorazione del legno da oltre 30 anni.\n\nFin dagli anni '90 Carmine porta avanti un mestiere fatto di precisione, cura del dettaglio e rispetto dei materiali naturali. La sua professionalità lo ha portato a lavorare in tutta la Sicilia, realizzando pavimenti, restauri e rifiniture che uniscono estetica, solidità e durata nel tempo.\n\nOgni progetto viene seguito personalmente: dal sopralluogo alla scelta dei materiali, dalla posa ai trattamenti finali. L'obiettivo è creare ambienti caldi, eleganti e su misura, trasformando ogni casa in un luogo accogliente con la bellezza del legno naturale.",
  mission: "La mia missione è semplice: trasformare gli spazi con la bellezza senza tempo del legno, utilizzando tecniche artigianali e materiali di prima qualità. Ogni progetto è per me un'opera d'arte.",
  values: [
    { title: "Qualità", description: "Solo i migliori materiali e le tecniche più accurate." },
    { title: "Puntualità", description: "Rispetto sempre i tempi concordati." },
    { title: "Trasparenza", description: "Preventivi chiari e senza sorprese." },
    { title: "Professionalità", description: "Formazione continua e certificazioni aggiornate." }
  ],
  certifications: [
    {
      title: "Oltre 30 anni di esperienza",
      description: "Un mestiere tramandato nel tempo, con migliaia di ore di lavoro su parquet e legno.",
      icon: "Award"
    },
    {
      title: "1000+ clienti soddisfatti",
      description: "Interventi eseguiti in case, negozi e strutture in tutta la Sicilia.",
      icon: "Heart"
    },
    {
      title: "Professionalità certificata dal passaparola",
      description: "La maggior parte dei nuovi clienti arriva tramite raccomandazioni dirette.",
      icon: "MessageCircle"
    }
  ]
};
